module.exports = __webpack_public_path__ + "img/image-9.9cdb80c8.webp";